// @mui
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { alpha, useTheme } from '@mui/material/styles'
//
import { HeaderSimple as Header } from '../_common'

type Props = {
  children: React.ReactNode
}

export default function AuthLayout({ children }: Props) {
  const theme = useTheme()

  return (
    <>
      <Header />

      <Box
        component='main'
        sx={{
          py: { xs: 8, md: 12 },
          display: 'flex',
          minHeight: '100vh',
          textAlign: 'center',
          px: { xs: 2, md: 0 },
          position: 'relative',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          background: `linear-gradient(135deg, ${alpha(
            theme.palette.primary.main,
            0.08,
          )} 0%, ${alpha(theme.palette.primary.dark, 0.05)} 50%, ${
            theme.palette.background.default
          } 100%)`,
          '&:before': {
            content: "''",
            position: 'absolute',
            top: -140,
            left: -140,
            width: 420,
            height: 420,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${alpha(
              theme.palette.primary.main,
              0.22,
            )} 0%, transparent 70%)`,
            zIndex: 0,
          },
          '&:after': {
            content: "''",
            position: 'absolute',
            bottom: -160,
            right: -160,
            width: 480,
            height: 480,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${alpha(
              theme.palette.primary.dark,
              0.18,
            )} 0%, transparent 70%)`,
            zIndex: 0,
          },
        }}
      >
        <Card
          sx={{
            py: { xs: 4, md: 5 },
            px: { xs: 3, md: 4 },
            width: '100%',
            maxWidth: 440,
            zIndex: 1,
            borderRadius: 3,
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.04)',
            backdropFilter: 'blur(10px)',
            background: alpha(theme.palette.background.paper, 0.92),
          }}
        >
          {children}
        </Card>
      </Box>
    </>
  )
}
